import Container from '@/components/base/Container';
import Section from '@/components/base/Section';
import ButtonLink from '@/components/base/ButtonLink';
import { splitImages } from '@/mocks/site';
import Reveal from '@/components/base/Reveal';

export default function SharedSpacesFeature() {
  return (
    <Section labelledBy="shared-heading">
      <Container>
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-x-14">
          <div className="lg:col-span-7">
            <Reveal variant="wipe">
              <div className="aspect-[4/3] w-full overflow-hidden rounded-[12px] bg-background-100 lg:aspect-auto lg:h-[460px]">
                <img src={splitImages.shared} alt="Well kept residential community pool deck and planted borders" title="Shared spaces in a managed residential community" className="h-full w-full object-cover object-center" />
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-5 lg:pt-6">
            <Reveal delay={100}>
              <p className="mb-3 font-label text-[12px] font-semibold uppercase tracking-[0.14em] text-accent-500 md:text-[13px]">Shared spaces</p>
            </Reveal>
            <Reveal delay={200}>
              <h2 id="shared-heading" className="font-heading text-[28px] font-semibold leading-[1.15] tracking-[-0.01em] text-[#222222] md:text-[34px] lg:text-[38px]">
                The common areas set the tone for everyone.
              </h2>
            </Reveal>
            <div className="mt-5 space-y-4">
              <p className="text-[16px] leading-[1.62] text-foreground-700">
                Lobbies, pools, courtyards, mail areas and walking paths are where residents form their impression of a community. Keeping them clean, safe and ready to use is a large part of our work.
              </p>
              <p className="text-[16px] leading-[1.62] text-foreground-700">
                We coordinate cleaning and landscaping vendors, schedule amenity maintenance around resident use and check shared areas during regular site visits.
              </p>
            </div>
            <div className="mt-7">
              <ButtonLink to="/services" variant="text">View grounds &amp; shared space services</ButtonLink>
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
}